var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideBarManage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.9609H4.99999C3.89542 17.9609 2.99999 17.0655 3 15.9609L3.00008 3.96093C3.00008 2.85636 3.89551 1.96094 5.00008 1.96094H14.0003C15.1049 1.96094 16.0003 2.85637 16.0003 3.96094V7.46094M13.0003 13.3423C13.0003 12.2617 13.8957 11.3857 15.0003 11.3857C16.1049 11.3857 17.0003 12.2617 17.0003 13.3423C17.0003 14.4228 16.1049 15.2988 15.0003 15.2988M15.0003 18.0361V17.9609M6.50031 5.96094H12.5003M6.50031 8.96094H12.5003M6.50031 11.9609H9.50031",
    stroke: "#F3F3F3",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBarManage);
export default __webpack_public_path__ + "static/media/SideBarManage.1b81acbcbbf0ed77c25387021ed238a3.svg";
export { ForwardRef as ReactComponent };